import { render, staticRenderFns } from "./FixedWireless.vue?vue&type=template&id=29f3acf0&"
import script from "./FixedWireless.vue?vue&type=script&lang=js&"
export * from "./FixedWireless.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSeparator} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSeparator})
